import moment from 'moment';
import PersistentData from './PersistentData';

export default class SettingsData extends PersistentData{
    constructor(rootPath, subPath){
        super((rootPath || '') + '/Settings' + (subPath? '/' + subPath:''));
    }
}


// WEBPACK FOOTER //
// ./src/api/SettingsData.js